import {NgModule, LOCALE_ID} from "@angular/core";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {routing} from "./app.routing";
import {AppComponent} from "./components";
import {directives} from "./directives";
import {services} from "./services";

import {registerLocaleData} from "@angular/common";
import localeNl from "@angular/common/locales/nl";
import {SharedModule} from "./shared/shared.module";
import {ForgotPasswordDialogComponent} from "./login/forgot-password/forgot-password-dialog.component";
import {PreloadAllModulesWithDelay} from "./preload";
import {CoreModule} from "./core/core.module";
import {LandingPageComponent} from "./landing-page/landing-page.component";
import {RegisterComponent} from "./register/register.component";
import {UnregisterComponent} from "./unregister/unregister.component";
import {VisitorService} from "./visitor/visitor.service";
import { CompanyService } from "./visitor/company.service";
import { SchoolService } from "./visitor/school.service";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatGridListModule} from "@angular/material/grid-list";
import {FrontdeskComponent} from "./frontdesk/frontdesk.component";
import {VisitorCollectionComponent} from "./visitor/visitor-collection/visitor-collection.component";
import {VisitorFilterComponent} from "./visitor/visitor-filter/visitor-filter.component";
import {UnregisterDialogComponent} from "./unregister-dialog/unregister-dialog.component";
import {VisitorComponent} from "./visitor/visitor/visitor.component";
import {NgxMatDatetimePickerModule, NgxMatTimepickerModule} from "@angular-material-components/datetime-picker";
import {MatStepperModule} from "@angular/material/stepper";
import {ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import { MainComponent } from "./main/main.component";
import { CustomBtnComponent } from "./custom-btn/custom-btn.component";
import {DurationPipe} from "./duration.pipe";


registerLocaleData(localeNl);

@NgModule({
  declarations: [
    directives,
    AppComponent,
    LandingPageComponent,
    RegisterComponent,
    UnregisterComponent,
    FrontdeskComponent,
    VisitorCollectionComponent,
    VisitorFilterComponent,
    UnregisterDialogComponent,
    VisitorComponent,
    MainComponent,
    CustomBtnComponent,
    DurationPipe,

  ],
  bootstrap: [AppComponent],
  entryComponents: [ForgotPasswordDialogComponent],
  providers: [
    {provide: LOCALE_ID, useValue: "nl-NL"},
    services,
    PreloadAllModulesWithDelay,
    VisitorService,
    CompanyService,
    SchoolService
  ],
  imports: [
    MatSnackBarModule,
    MatButtonModule,
    BrowserAnimationsModule,
    CoreModule,
    MatIconModule,
    SharedModule,
    routing,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    MatStepperModule,
    ReactiveFormsModule
  ],
  exports: [
    DurationPipe,
  ]
})
export class AppModule {
}
